<script lang="ts">
  export let gameInSession: boolean;
</script>

<style>
  button#play-btn {
    width: 5.5rem;
    margin: 10px 0;
    padding: 10px 20px;
    font-size: 1.1rem;
    font-weight: 600;
    color: black;
    background-color: hsla(69, 66%, 62%, 1);
    box-shadow: 1px 1px 3px black;
    cursor: pointer;
  }
  button#play-btn:active {
    box-shadow: inset 0 0 3px black;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    button#play-btn {
      width: 7.5rem;
      font-size: 1.3rem;
      margin: 10px 0;
      padding: 14px 25px;
    }
  }
</style>

<!-- {#if gameInSession}
  <button disabled={gameInSession} id="play-btn" on:click>Reset</button>
{/if} -->
<button disabled={gameInSession} id="play-btn" on:click>Play</button>
